export default {
  title: 'Timesheet',
  description: 'Track and manage work hours',
  week_of: 'Week of {{date}}',
  previous_week: 'Previous Week',
  next_week: 'Next Week',
  this_week: 'This Week',
  total_hours: 'Total Hours',
  daily_total: 'Daily Total',
  weekly_total: 'Weekly Total',
  clock_in: 'Clock In',
  clock_out: 'Clock Out',
  hours: 'Hours',
  notes: 'Notes',
  add_entry: 'Add Entry',
  edit_entry: 'Edit Entry',
  view_entry: 'View entry',
  not_clocked_out: 'Not clocked out yet',
  no_selfie: 'No selfie',
  no_location: 'No location',
  delete_entry: 'Delete Entry',
  lock_week: 'Lock Week',
  unlock_week: 'Unlock Week',
  locked_by: 'Locked by {{name}} on {{date}}',
  week_locked: 'This week is locked',
  staff_member: 'Staff Member',
  all_staff: 'All Staff',
  // EP-154: a shift clocked in from the dashboard, and its proofs.
  in_progress: 'In progress',
  location: 'location',
  attachments: 'Attachments',
  attachments_hint: 'Upload photos or receipts (max 5)',
  no_entries: 'No entries for this week',
  setup_guide: 'Click the + button on any day to log your work hours. You can add multiple entries per day.',
  guide_step_1: 'Click + on a day',
  guide_step_2: 'Enter clock in/out or hours',
  guide_step_3: 'Attach photos if needed',
  confirm_delete: 'Delete this timesheet entry?',
  confirm_lock: 'Lock this week? Staff will not be able to edit entries.',
  confirm_unlock: 'Unlock this week? Staff will be able to edit entries again.',
  // EP-141 T141-002 — moved from the visitors:calendar.* namespace (the
  // retired StaffCalendarPage). previous_week/next_week/title/subtitle_*
  // were NOT carried over: there is now only one week nav and one page
  // title/header on /timesheet (this file's own previous_week/next_week/
  // title, above), so those calendar-specific copies had no reader left.
  schedule_label: 'Schedule',
  hours_label: 'Hours',
  // T141-017 — owner-chosen vocabulary: "Entry", not "Shift", everywhere on
  // this page, matching the existing add_entry/edit_entry/delete_entry
  // above. The header Add-shift button now reuses add_entry directly rather
  // than duplicating the same string under a second key.
  //
  // T141-011 — modal title when an admin/owner adds an entry for someone
  // else via that person's row; keeps the target visible rather than silent.
  add_entry_for: 'Add Entry for {{name}}',
  legend_entry: 'Entry',
  legend_visit: 'Visit',
  // T141-010 — staff/accountant self-lock. Separate copy from lock_week/
  // confirm_lock on purpose: unlike admin/owner locking someone else's week,
  // this is one-way for the person clicking it, and the copy has to say so.
  lock_my_week: 'Lock my week',
  confirm_self_lock: 'Lock your week? You will not be able to edit entries in it afterwards, and only an admin or owner can unlock it.',
  // T141-016 — shown in the add/edit modal when the TARGET's week is locked
  // and the write is still going through (admin/owner bypass). Informational
  // only, never a gate: the write was already allowed before this copy ever
  // renders.
  locked_week_notice: 'This week is locked. As an admin or owner, you can still record this entry.',
  messages: {
    entry_created: 'Entry created successfully',
    entry_updated: 'Entry updated successfully',
    entry_deleted: 'Entry deleted successfully',
    week_locked: 'Week locked successfully',
    week_unlocked: 'Week unlocked successfully',
  },
  errors: {
    week_not_ended: 'A week can only be locked once it has ended',
    open_shift_in_week: 'Someone is still clocked in during this week. Close that shift first',
  },
  days: {
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun',
  },
}
